import React from 'react';
import { Route, Routes as RoutesComponent } from 'react-router-dom';
import { Onboarding } from './modules/onboarding/Onboarding';
import { Auth } from './modules/auth/Auth';
import { Layout } from './shared/components/layout/Layout';
import { OrderActivity } from './modules/order/OrderActivity';
import { Pairs } from './modules/pairs/Pairs';
import { Logout } from './modules/auth/Logout';
import { Dashboard } from './modules/dashboard/Dashboard';
import { SettingLayout } from './modules/settings/components/SettingLayout';
import { SettingAccount } from './modules/settings/SettingAccount';
import { SettingStrategy } from './modules/settings/SettingStrategy';
import { SettingBroker } from './modules/settings/SettingBroker';
import { SettingRisk } from './modules/settings/SettingRisk';
import { OrderHistory } from './modules/order/OrderHistory';
import { RoleAuthorizationAdmin } from './modules/rbca/RoleAuthorization';
import { Users } from './modules/user/Users';
import { SettingBuild } from './modules/settings/SettingBuild';
import { AuthProvider } from './modules/auth/AuthProvider';
import { AuthInactive } from './modules/auth/AuthInactive';
import { RBACPermissions } from './modules/rbca/rbac-types';
import { SettingFlush } from './modules/settings/SettingFlush';

export const Routes: React.FC = () => {
  return (
      <RoutesComponent>
        <Route path="/auth" element={<Auth />} />
        <Route path="/auth/inactive" element={<AuthInactive />} />
        <Route path="/logout" element={<Logout />} />
        <Route
          path="*"
          element={
            <AuthProvider>
              <RoutesComponent>
                <Route
                  path="/"
                  element={
                    <Layout>
                      <Dashboard />
                    </Layout>
                  }
                />

                <Route path="/onboarding" element={<Onboarding />} />

                <Route
                  path="/order-activity"
                  element={
                    <Layout>
                      <OrderActivity />
                    </Layout>
                  }
                />
                <Route
                  path="/order-history"
                  element={
                    <Layout>
                      <OrderHistory />
                    </Layout>
                  }
                />
                <Route
                  path="/pairs"
                  element={
                    <Layout>
                      <Pairs />
                    </Layout>
                  }
                />

                <Route
                  path="/setting/account"
                  element={
                    <Layout>

                      <SettingLayout>
                        <SettingAccount />
                      </SettingLayout>
                    </Layout>
                  }
                />

                <Route
                  path="/setting/strategy"
                  element={
                    <Layout>
                      <RoleAuthorizationAdmin
                        render={() => (
                          <SettingLayout>
                            <SettingStrategy />
                          </SettingLayout>
                        )}
                      />
                    </Layout>
                  }
                />
                <Route
                  path="/setting/platform-status"
                  element={
                    <Layout>
                      <RoleAuthorizationAdmin
                        render={() => (
                          <SettingLayout>
                            <SettingBuild />
                          </SettingLayout>
                        )}
                        permission={RBACPermissions.BUILD}
                      />
                    </Layout>
                  }
                />
                <Route
                  path="/setting/flush"
                  element={
                    <Layout>
                      <RoleAuthorizationAdmin
                        render={() => (
                          <SettingLayout>
                            <SettingFlush />
                          </SettingLayout>
                        )}
                        permission={RBACPermissions.FLUSH}
                      />
                    </Layout>
                  }
                />
                <Route
                  path="/users"
                  element={
                    <Layout>
                      <RoleAuthorizationAdmin render={() => <Users />} />
                    </Layout>
                  }
                />
                <Route
                  path="/setting/broker-connection"
                  element={
                    <Layout>
                      <SettingLayout>
                        <SettingBroker />
                      </SettingLayout>
                    </Layout>
                  }
                />
                <Route
                  path="/setting/risk-management"
                  element={
                    <Layout>
                      <SettingLayout>
                        <SettingRisk />
                      </SettingLayout>
                    </Layout>
                  }
                />

              </RoutesComponent>
            </AuthProvider>
          }
        />
      </RoutesComponent>
  );
};
